import ArrayUtil from './ArrayUtil';

export const DEFAULT_COMMUNICATION_TEMPLATE = {
  INVITE: 'EMAIL_INVITE',
  THANKS: 'EMAIL_THANKYOU',
  REMINDER: 'EMAIL_REMINDER',
  FEEDBACK: 'EMAIL_FEEDBACK',
};

export const SURVEYS_COMMUNICATION_TEMPLATE = {
  INVITE: 'EMAIL_INVITE_360',
  REMINDER: 'EMAIL_REMINDER_360',
};
const DEFAULT_TEMPLATE = {
  id: -1,
  name: 'Default',
};
const getDefaultCommuTemplate = (templates) => {
  const defaultList = {
    invites: [DEFAULT_TEMPLATE],
    thanks: [DEFAULT_TEMPLATE],
    reminders: [DEFAULT_TEMPLATE],
    feedbacks: [DEFAULT_TEMPLATE],
  };
  templates.forEach((temp) => {
    const id = parseInt(temp.id, 10);
    switch (temp.type) {
      case DEFAULT_COMMUNICATION_TEMPLATE.INVITE:
        defaultList.invites.push({ ...temp, id });
        break;
      case DEFAULT_COMMUNICATION_TEMPLATE.THANKS:
        defaultList.thanks.push({ ...temp, id });
        break;
      case DEFAULT_COMMUNICATION_TEMPLATE.REMINDER:
        defaultList.reminders.push({ ...temp, id });
        break;
      case DEFAULT_COMMUNICATION_TEMPLATE.FEEDBACK:
        defaultList.feedbacks.push({ ...temp, id });
        break;
      default:
        break;
    }
  });

  return defaultList;
};

const updateCommuTemplatesForSurvey = (commuList, templates) => {
  templates.forEach((temp) => {
    switch (temp.type) {
      case SURVEYS_COMMUNICATION_TEMPLATE.INVITE:
        commuList.invites.push({
          ...temp,
          id: parseInt(temp.id, 10),
        });
        break;
      case SURVEYS_COMMUNICATION_TEMPLATE.REMINDER:
        commuList.reminders.push({
          ...temp,
          id: parseInt(temp.id, 10),
        });
        break;
      default:
        break;
    }
  });
  return commuList;
};

export const getCommunicationTemplateForSurvey = (templates) => {
  let commuList = getDefaultCommuTemplate(templates);
  commuList = updateCommuTemplatesForSurvey(commuList, templates);
  return commuList;
};

// const updateCommuTemplatesForAsmt = (commuList, templates) => {
//   templates.forEach((temp) => {
//     switch(temp.type) {
//       case SURVEYS_COMMUNICATION_TEMPLATE.INVITE:
//         commuList.invites.push(temp);
//         break;
//       case SURVEYS_COMMUNICATION_TEMPLATE.REMINDER:
//         commuList.reminders.push(temp);
//         break;
//       default: break;
//     }
//   });
//   return commuList;
// }

export const getCommunicationTemplateForAsmt = (templates) => {
  const commuList = getDefaultCommuTemplate(templates);
  // commuList = updateCommuTemplatesForAsmt(commuList, templates);
  return commuList;
};

export const getAbilities = (list) => {
  const abilities = [];
  if (ArrayUtil.isNotEmpty(list)) {
    list.forEach((ability) => {
      abilities.push(ability.id);
    });
  }

  return abilities;
};

export const buildEmailTemplatesData = (values) => {
  const {
    feedbackTemplateId, inviteTemplateId, reminderTemplateId, thankYouTemplateId,
  } = values;
  return {
    feedbackTemplateId: feedbackTemplateId !== -1 ? feedbackTemplateId : null,
    inviteTemplateId: inviteTemplateId !== -1 ? inviteTemplateId : null,
    reminderTemplateId: reminderTemplateId !== -1 ? reminderTemplateId : null,
    thankYouTemplateId: thankYouTemplateId !== -1 ? thankYouTemplateId : null,
  };
};

export const filterSelectedDimensions = (dims, selected) => {
  const selectedEntityList = [];
  if (ArrayUtil.isNotEmpty(dims) && ArrayUtil.isNotEmpty(selected)) {
    selected.forEach((selectedId) => {
      const item = dims.find(dim => dim.name === selectedId);
      if (item) {
        selectedEntityList.push(item);
      }
    });
  }
  return selectedEntityList;
};
